<template>
   <div class="background" :style="{ backgroundImage: 'url(\'' + require('@/assets/images/bg-content.png') + '\')' }">
   <b-form ref="form">
    <b-container class="mb-10">
      <b-row>
          <h1 class="text-uppercase font-weight-bold mt-4 mb-4 font-size-16">ereszkalkulátor</h1>
          <p class="text-justify">
              Számítsa ki, a szükséges bádogosipari termékek közül mennyire van szüksége az ereszrendszer kiépítéséhez! Használja ereszkalkulátorunkat, melyben a tető tulajdonságainak és saját igényeinek megadásával könnyedén megtudhatja, hogy otthonához többek között milyen hosszú ereszcsatornára, lefolyóra, hány betorkollóra vagy zárt végre lesz szüksége. A bádogos ipari termékek közül ereszkalkulátorunkban választhat külső vagy belső peremezésű, horganyzott vagy további. színezett ereszrendszerek közül is.
              Amennyiben segítségre van szüksége a beszerzéssel kapcsolatban, kérjen tőlünk ajánlatot, kollégáink állnak rendelkezésére bádogos ipari termékeinkkel kapcsolatban!
          </p>
      </b-row>
      <b-row>
       <b-col col lg="4" class="houses mt-3">
         <h5 class="font-weight-bold text-uppercase mb-5">1. válasszon háztípust</h5>
         <b-row>
           <b-col col lg="6" :class="isFirst || houses[0].show==0 ? '' : 'bordered'">
             <img class="w-100" @click="changeData(1)" src="@/assets/images/ereszkalkulator_kicsi_haz_felnyeregteto_szurke.png" v-if="houses[0].show==0 && !isFirst">
             <img class="w-100" @click="changeData(1)" src="@/assets/images/ereszkalkulator_kicsi_haz_felnyeregteto_szines.png"  v-if="houses[0].show==1 || isFirst">
             <p class="house-name">{{houses[0].name}}</p>
           </b-col>
           <b-col col lg="6" :class="isFirst || houses[1].show==0 ? '' : 'bordered'">
              <img class="w-100"  @click="changeData(2)" src="@/assets/images/ereszkalkulator_kicsi_haz_kontyolt_nyeregteto_szurke.png" v-if="houses[1].show==0 && !isFirst">
              <img class="w-100"  @click="changeData(2)" src="@/assets/images/ereszkalkulator_kicsi_haz_kontyolt_nyeregteto_szines.png"  v-if="houses[1].show==1 || isFirst">
              <p class="house-name">{{houses[1].name}}</p>
           </b-col>
         </b-row>
         <b-row>
           <b-col col lg="6" :class="isFirst|| houses[2].show==0 ? '' : 'bordered'">
             <img class="w-100"  @click="changeData(3)" src="@/assets/images/ereszkalkulator_kicsi_haz_l_nyeregteto_szurke.png" v-if="houses[2].show==0 && !isFirst">
             <img class="w-100" @click="changeData(3)" src="@/assets/images/ereszkalkulator_kicsi_haz_l_nyeregteto_szines.png"  v-if="houses[2].show==1 || isFirst">
             <p class="house-name">{{houses[2].name}}</p>
           </b-col>
           <b-col col lg="6" :class="isFirst|| houses[3].show==0 ? '' : 'bordered'">
              <img class="w-100"  @click="changeData(4)" src="@/assets/images/ereszkalkulator_kicsi_haz_nyeregteto_szurke.png" v-if="houses[3].show==0 && !isFirst">
             <img class="w-100" @click="changeData(4)" src="@/assets/images/ereszkalkulator_kicsi_haz_nyeregteto_szines.png"  v-if="houses[3].show==1 || isFirst">
             <p class="house-name">{{houses[3].name}}</p>
           </b-col>
         </b-row>
         <b-row>
           <b-col col lg="6" :class="isFirst|| houses[4].show==0 ? '' : 'bordered'">
             <img class="w-100"  @click="changeData(5)" src="@/assets/images/ereszkalkulator_kicsi_haz_osszetett_kontyolt_nyeregteto_szurke.png" v-if="houses[4].show==0 && !isFirst">
             <img class="w-100" @click="changeData(5)" src="@/assets/images/ereszkalkulator_kicsi_haz_osszetett_kontyolt_nyeregteto_szines.png"  v-if="houses[4].show==1 || isFirst">
             <p class="house-name">{{houses[4].name}}</p>
           </b-col>
           <b-col col lg="6" :class="isFirst|| houses[5].show==0 ? '' : 'bordered'">
              <img class="w-100"  @click="changeData(6)" src="@/assets/images/ereszkalkulator_kicsi_haz_osszetett_nyeregteto_szurke.png" v-if="houses[5].show==0 && !isFirst">
             <img class="w-100" @click="changeData(6)" src="@/assets/images/ereszkalkulator_kicsi_haz_osszetett_nyeregteto_szines.png"  v-if="houses[5].show==1 || isFirst">
             <p class="house-name">{{houses[5].name}}</p>
           </b-col>
         </b-row>
       </b-col>
       <b-col col lg="8" class="mt-3">
         <h5 class="font-weight-bold text-uppercase mb-5">2. Adja meg a tervezéshez szükséges adatokat</h5>
         <b-row>
           <b-col col lg="7">
            <span class="text-uppercase">2.1 Tetőhosszúság</span>
              <img class="w-100" :src="getImgUrl(getHouseImage())">
          </b-col>
          <b-col col lg="5">     
                <b-form-input class="budafer-input" type="number" placeholder="A: (méter)" step="0.1" v-if="forms > 0" min="1" max="100" v-model="result.inputs[0]" :required="forms > 0 ? true : false"></b-form-input>
                <b-form-input class="budafer-input" type="number" placeholder="B: (méter)" step="0.1" v-if="forms > 1" min="1" max="100" v-model="result.inputs[1]" :required="forms > 1 ? true : false"></b-form-input>
                <b-form-input class="budafer-input" type="number" placeholder="C: (méter)" step="0.1" v-if="forms > 2" min="1" max="100" v-model="result.inputs[2]" :required="forms > 2 ? true : false"></b-form-input>
                <b-form-input class="budafer-input" type="number" placeholder="D: (méter)" step="0.1" v-if="forms > 3" min="1" max="100" v-model="result.inputs[3]" :required="forms > 3 ? true : false"></b-form-input>
                <b-form-input class="budafer-input" type="number" placeholder="E: (méter)" step="0.1" v-if="forms > 4" min="1" max="100" v-model="result.inputs[4]" :required="forms > 4 ? true : false"></b-form-input>
          </b-col> 
          </b-row>
       </b-col>
      </b-row>
       <b-row class="mt-5">
        <b-col col lg="4">
          <p class="text-uppercase">2.2 TETŐMAGASSÁG</p>
          <b-row>
            <b-col col lg="6">
              <img class="w-100" src="@/assets/images/ereszkalkulator_22_tetomagassag.png">
            </b-col>
            <b-col col lg="6">
              
            <b-form-input class="budafer-input" type="number" placeholder="A: (méter)" v-model="result.inputs[5]" step="0.1" min="1" max="100" required></b-form-input>
            <b-form-input class="budafer-input" type="number" placeholder="B: (méter)" v-model="result.inputs[6]" step="0.1" min="1" max="100" required></b-form-input>
          
            </b-col>
          </b-row>
        </b-col>
        <b-col col lg="4">
          <p class="text-uppercase">2.3 Ereszrendszer Tulajdonságai</p>
          <b-row>
            <b-col col lg="6">
              <img class="w-100" src="@/assets/images/ereszkalkulator_23_eresztulajdonsag.png">
            </b-col>
            <b-col col lg="6">
                <b-form-select class="budafer-input" v-model="result.selected[1]" :options="options[1]" required></b-form-select>  
            </b-col>
          </b-row>
        </b-col>
        <b-col col lg="4">
          <p class="text-uppercase">2.4 KÖNYÖK TÍPUSA</p>
          <b-row>
            <b-col col lg="6">
              <img class="w-50 pointer" v-if="(result.selected[2] == null || result.selected[2] == 'dupla')  && !isFirst"  @click="setSelected(2,'szimpla')" src="@/assets/images/ereszkalkulator_24_konyoktipusa_bal_konyok_szurke.png">
              <img class="w-50 pointer" v-if="result.selected[2] == 'szimpla' || isFirst" @click="setSelected(2,'szimpla')" src="@/assets/images/ereszkalkulator_24_konyoktipusa_bal_konyok_fekete.png">
              <img class="w-50 pointer" v-if="(result.selected[2] == null || result.selected[2] == 'szimpla')  && !isFirst" @click="setSelected(2,'dupla')" src="@/assets/images/ereszkalkulator_24_konyoktipusa_jobb_konyok_szurke.png">
              <img class="w-50 pointer" v-if="result.selected[2] == 'dupla' || isFirst" @click="setSelected(2,'dupla')" src="@/assets/images/ereszkalkulator_24_konyoktipusa_jobb_konyok_fekete.png">
            </b-col>
            <b-col col lg="6">
              
            <b-form-select class="budafer-input" v-model.lazy="result.selected[2]" :options="options[2]" required></b-form-select>  
          
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mb-5 mt-5">
        <b-col col lg="4">
          <p class="text-uppercase">2.5 BILINCS MÉRETE</p>
          <b-row>
            <b-col col lg="6">
              <img class="w-100" src="@/assets/images/ereszkalkulator_25_bilics_merete_rovid_fekete_v2.png">
            </b-col>
            <b-col col lg="6">
                <b-form-select class="budafer-input" v-model="result.selected[3]" :options="options[3]" required></b-form-select>  
                <br><em>Szárhossz= Falvastagság + szigetelés + ráhagyás</em> 
            </b-col>
          </b-row>
        </b-col>
        <b-col col lg="4">
          <p class="text-uppercase">2.6 KIVITEL</p>
           <b-row>
            <b-col col lg="6">
              <img class="w-100 pointer" v-if="(result.selected[4] == null || result.selected[4] == 'Belső peremes')  && !isFirst" @click="setSelected(4,'Külső peremes')" src="@/assets/images/ereszkalkulator_26_minoseg_standard_szurke.png">
              <img class="w-100 pointer" v-if="result.selected[4] == 'Külső peremes' || isFirst" @click="setSelected(4,'Külső peremes')" src="@/assets/images/ereszkalkulator_26_minoseg_standard_fekete.png">
              <img class="w-100 pointer" v-if="(result.selected[4] == null || result.selected[4] == 'Külső peremes')  && !isFirst" @click="setSelected(4,'Belső peremes')" src="@/assets/images/ereszkalkulator_26_minoseg_premium_szurke.png">
              <img class="w-100 pointer" v-if="result.selected[4] == 'Belső peremes' || isFirst" @click="setSelected(4,'Belső peremes')"  src="@/assets/images/ereszkalkulator_26_minoseg_premium_fekete.png">
            </b-col>
            <b-col col lg="6">
              
                <b-form-select class="budafer-input" v-model="result.selected[4]" :options="options[4]" required></b-form-select>  
            
            </b-col>
          </b-row>
        </b-col>
        <b-col col lg="4">
          <p class="text-uppercase">2.7 SZÍN</p>
          <b-row class="color-image">
            <b-col col lg="6">
            <b-row><b-col col lg="12"><img class="w-100 pointer" :class="result.selected[5]=='standard'  || isFirst ? '' : 'non-selected'" src="@/assets/images/colors/standard.png"  @click="setSelected(5,'horganyzott')"></b-col></b-row>
            <b-row class="mt-1 image-row">
              <b-col class="pr-0"><img class="w-100 pointer" :class="result.selected[5]=='8003' || isFirst ? '' : 'non-selected'" src="@/assets/images/colors/8003.png" @click="setSelected(5,'8003')"></b-col>
              <b-col class="pl-1 pr-1"><img class="w-100 pointer" :class="result.selected[5]=='3009' || isFirst ? '' : 'non-selected'" src="@/assets/images/colors/3009.png" @click="setSelected(5,'3009')"></b-col>
              <b-col class="pl-0"><img class="w-100 pointer" :class="result.selected[5]=='3016' || isFirst ? '' : 'non-selected'" src="@/assets/images/colors/3016.png" @click="setSelected(5,'3016')"></b-col>
            </b-row>
             <b-row class="mt-1 image-row">
              <b-col class="pr-0"><img class="w-100 pointer" :class="result.selected[5]=='8011' || isFirst ? '' : 'non-selected'" src="@/assets/images/colors/8011.png" @click="setSelected(5,'8011')"></b-col>
              <b-col class="pl-1 pr-1"><img class="w-100 pointer" :class="result.selected[5]=='8004' || isFirst ? '' : 'non-selected'" src="@/assets/images/colors/8004.png" @click="setSelected(5,'8004')"></b-col>
              <b-col class="pl-0"><img class="w-100 pointer" :class="result.selected[5]=='7016' || isFirst ? '' : 'non-selected'" src="@/assets/images/colors/7016.png" @click="setSelected(5,'7016')"></b-col>
            </b-row>
             <b-row class="mt-1 image-row">
              <b-col class="pr-0"><img class="w-100 pointer" :class="result.selected[5]=='8017' || isFirst ? '' : 'non-selected'" src="@/assets/images/colors/8017.png" @click="setSelected(5,'8017')"></b-col>
              <b-col class="pl-1 pr-1"><img class="w-100 pointer" :class="result.selected[5]=='9007' || isFirst ? '' : 'non-selected'" src="@/assets/images/colors/9007.png" @click="setSelected(5,'9007')"></b-col>
              <b-col class="pl-0"><img class="w-100 pointer" :class="result.selected[5]=='9010' || isFirst ? '' : 'non-selected'" src="@/assets/images/colors/9010.png" @click="setSelected(5,'9010')"></b-col>
            </b-row>
            </b-col>
            <b-col col lg="6" class="color-selector">
              
                <b-form-select class="budafer-input" v-model="result.selected[5]" :options="options[5]" required></b-form-select>  
            
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col col lg="12">
          <b-button class="bt-next float-right sendbutton" @click="SendData()">Kalkuláció indítása</b-button>
        </b-col>
      </b-row>
    </b-container>
   </b-form>
   </div>
</template>
<script>
export default {
  props: ['houses','step','result','first'],
    data() {
        return {
          isFirst:this.first,
          bighouse:"ereszkalkulator_haz_felnyeregteto_szines.png",
          forms:this.getHouseSide(),
          options: [
            [
              { value: '0,45', text: 'Normál', selected: '0,45'}
            ],
             [
              { value: null, text: 'Rendszerátmérő',disabled: true },
              { value: '25', text: '25 cm' },
              { value: '33', text: '33 cm' },
              { value: '40', text: '40 cm' }
            ],
            [
              { value: null, text: 'Típus',disabled: true },
              { value: 'szimpla', text: 'könyök' },
              { value: 'dupla', text: 'hattyúnyak' }
            ],
            [
              { value: null, text: 'Szárhossz',disabled: true },
              { value: '120', text: '120 mm' },
              { value: '150', text: '150 mm' },
              { value: '180', text: '180 mm' },
              { value: '250', text: '250 mm' },
              { value: '300', text: '300 mm' }
            ],
            [
              { value: null, text: 'Kivitel',disabled: true },
              { value: 'Külső peremes', text: 'Külső peremes' },
              { value: 'Belső peremes', text: 'Belső peremes' }
            ],
            [
              { value: null, text: 'Szín kiválasztása',disabled: true },
              { value: 'horganyzott', text: 'Horganyzott' },
              { value: '8003', text: 'RAL 8003 Tűzbarna' },
              { value: '3009', text: 'RAL 3009 Bordó' },
              { value: '3016', text: 'RAL 3016 Téglavörös' },
              { value: '8011', text: 'RAL 8011 Barna' },
              { value: '8004', text: 'RAL 8004 Cserépvörös' },
              { value: '7016', text: 'RAL 7016 Antacit' },
              { value: '8017', text: 'RAL 8017 Rézbarna' },
              { value: '9007', text: 'RAL 9007 Ezüst' },
              { value: '9010', text: 'RAL 9010 Fehér' }
            ],
          ]
        }
    },
  methods: {
    getImgUrl(pic) {
      return require('../assets/images/'+pic)
    },
    getHouseImage(){
      let image = "";
        this.houses.forEach(element => {
          if(element.show == 1) image = element.img;
        });
        return image;
    },
    getHouseSide(){
         let side = "";
        this.houses.forEach(element => {
          if(element.show == 1) side = element.side;
        });
        return side;
    },
    changeData(id){
        this.isFirst = false;
        this.houses.forEach(element => {
          if(element.id == id)
          {
            element.show = 1;
            this.bighouse=element.img;
            this.forms=element.side;
          }else
          {
            element.show = 0;
          }
        });
    },
    setSelected(id,content){
      this.isFirst = true;
      this.isFirst = false;
      this.result.selected[id] = content;
    },
    SendData()
    {
      if (this.$refs.form.checkValidity()) {
        this.$emit('update:result', this.result);
        this.$emit('update:step', 2);
        this.$emit('update:first', false);
      } else {
        this.$refs.form.reportValidity();
      }
    },
  }
}    
</script>
<style scoped>
  @import url('https://fonts.googleapis.com/css?family=Proza+Libre');
  h1{
    font-size: 2rem;
  }
  .pointer{
      cursor: pointer;
  }
  .houses img{
      cursor: pointer;
  }
  .houses .bordered{
      border: solid 1px;
      border-radius: 10px;
  }
  .mb-10{
    margin-bottom: 10rem !important;
  }
  .budafer-input{
    margin-bottom: 1.5rem;
    border:solid black 1px;
    border-radius:2rem;
    height:3rem;
    font-weight: bold;
  }
  .bt-next {
    border-radius: 1rem;
    background-color: #3d54a1;
    border: 0;
    font-size: 1.5rem;
    padding: 0.5rem 2rem;
    color: #fff;
    font-weight: 700;
    font-style: italic;
}
.non-selected{
  opacity: 0.6;
}
.custom-select{
  font-size: 0.9rem !important;
}
.house-name{
  font-size: 0.8rem;
  text-transform: uppercase;
  font-weight: bold;
  text-align: center !important;
}
@media (max-width:576px) {
   div{
     padding:10px;
   }
    .w-100 {
        width: 250px !important;
    }
     .w-50 {
        width: 100px !important;
    }
    .col{
      flex-basis: auto;
      text-align: center;
    }
    .color-image
    {
       flex-basis: 0;
    }
    .color-image div{
      padding:0 !important;
    }
    .color-image img{
      width:94% !important;
    }
    .image-row img{
      width:100px !important;
    }
    h1{
       font-size:2rem;
       text-align: center;
       width:100%;
    }
    .image-row .col{
      width:33% !important;
    }
    .color-selector{
      margin-top:50px;
    }
    .sendbutton{
      float:inherit !important;
    }
}
</style>